export const mockData = {
  hero: {
    headline: "Fuel Your XOLO",
    subline: "Energy with flavor that actually tastes good.",
    cta: "Shop Energy",
    heroImage: "https://customer-assets.emergentagent.com/job_brand-design-journey/artifacts/uqhiev9a_Berry%20rush.png"
  },
  
  flavors: [
    {
      id: 1,
      name: "Banana Shock",
      shortName: "Banana",
      tagline: "smooth operator",
      description: "Creamy banana meets clean energy. No weird aftertaste, just smooth power.",
      image: "https://customer-assets.emergentagent.com/job_brand-design-journey/artifacts/2lalwkzv_Banana%20shock.png",
      colorClass: "flavor-banana",
      accentColor: "#ffdc5e",
      price: 2.99
    },
    {
      id: 2,
      name: "Citrus Blast",
      shortName: "Citrus",
      tagline: "wake up call",
      description: "Zesty citrus punch that kicks in fast. Perfect for those 'I need energy now' moments.",
      image: "https://customer-assets.emergentagent.com/job_brand-design-journey/artifacts/xwuj0ix8_citrus%20blast.png",
      colorClass: "flavor-citrus",
      accentColor: "#ff6b35",
      price: 2.99
    },
    {
      id: 3,
      name: "Berry Rush",
      shortName: "Berry",
      tagline: "berry good vibes",
      description: "Mixed berries with a hint of mischief. Sweet, tart, and surprisingly refreshing.",
      image: "https://customer-assets.emergentagent.com/job_brand-design-journey/artifacts/uqhiev9a_Berry%20rush.png",
      colorClass: "flavor-berry",
      accentColor: "#8b5cf6",
      price: 2.99
    },
    {
      id: 4,
      name: "Extreme",
      shortName: "Extreme",
      tagline: "no chill",
      description: "Maximum caffeine, maximum flavor. For when you need to get stuff done.",
      image: "https://customer-assets.emergentagent.com/job_brand-design-journey/artifacts/sp2z6j0y_Extreme%20Rush.png",
      colorClass: "flavor-extreme",
      accentColor: "#ffd700",
      price: 3.49
    }
  ],

  taglines: [
    {
      id: 1,
      text: "if energy drinks grew on trees",
      subtitle: "they'd probably taste like XOLO"
    },
    {
      id: 2,
      text: "caffeine that doesn't make you jittery",
      subtitle: "weird, we know"
    },
    {
      id: 3,
      text: "finally, an energy drink your taste buds approve of",
      subtitle: "about time, right?"
    }
  ],

  about: {
    headline: "We're Not Like Other Energy Drinks",
    subtitle: "We're a cool energy drink",
    copy: "Born from the idea that energy drinks shouldn't taste like medicine or make you feel weird. XOLO is what happens when you actually care about flavor and clean ingredients."
  },

  shop: {
    varietyPack: {
      name: "The Flavor Explorer Pack",
      description: "Try all 4 flavors and find your favorite. Or keep them all, we won't judge.",
      price: 11.99,
      savings: "Save $0.97"
    }
  },

  newsletter: {
    headline: "Stay in the Loop",
    subline: "Get first dibs on new flavors and the occasional dad joke.",
    success: "You're in! Welcome to the XOLO family."
  }
};